import {
  formatCurrency,
  getSOVStatusLabel,
  getSOVStatusColor,
  SOV_STATUS,
} from "../constants/sovSetupData";

interface ContractAmount {
  amount?: number;
  currency?: { symbol: string };
}

interface ContractSummaryStripProps {
  contractAmount?: ContractAmount;
  total: number;
  variance: number;
  lineCount: number;
  divisionsCount: number;
  sovStatus?: string;
}

export default function ContractSummaryStrip({
  contractAmount,
  total,
  variance,
  lineCount,
  divisionsCount,
  sovStatus,
}: ContractSummaryStripProps) {
  const isMatch = Math.abs(variance) < 0.01;
  const varianceClass = isMatch
    ? "green"
    : Math.abs(variance) < 1000
      ? "amber"
      : "red";
  return (
    <div className="sovContractStrip">
      <div className="sovContractCell">
        <p className="sovContractLabel">Contract Amount</p>
        <p className="sovContractValue blue">
          {formatCurrency(
            contractAmount?.amount,
            contractAmount?.currency?.symbol,
          )}
        </p>
        <p className="sovContractSub">From project setup</p>
      </div>
      <div className="sovContractCell">
        <p className="sovContractLabel">SOV Total</p>
        <p className={`sovContractValue ${isMatch ? "green" : "red"}`}>
          {formatCurrency(total)}
        </p>
        <p className="sovContractSub">
          {isMatch
            ? "Matches contract ✓"
            : variance > 0
              ? "Exceeds contract ⚠"
              : "Below contract ⚠"}
        </p>
      </div>
      <div className="sovContractCell">
        <p className="sovContractLabel">Variance</p>
        <p className={`sovContractValue ${varianceClass}`}>
          {!isMatch && variance > 0 ? "+" : ""}
          {formatCurrency(isMatch ? 0 : variance)}
        </p>
        <p className="sovContractSub">
          {isMatch
            ? "No variance"
            : variance > 0
              ? "Over contract"
              : "Under contract"}
        </p>
      </div>
      <div className="sovContractCell">
        <p className="sovContractLabel">Line Items</p>
        <p className="sovContractValue">{lineCount}</p>
        <p className="sovContractSub">Across {divisionsCount} divisions</p>
      </div>
      <div className="sovContractCell">
        <p className="sovContractLabel">SOV Status</p>
        <p
          className="sovContractValue small"
          style={{ color: getSOVStatusColor(sovStatus ?? "") }}
        >
          {getSOVStatusLabel(sovStatus ?? "")}
        </p>
        <p className="sovContractSub">
          {sovStatus === SOV_STATUS.ACTIVE ? "Submitted" : "Not yet submitted"}
        </p>
      </div>
    </div>
  );
}
